"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    appConfigs: ()=>appConfigs,
    useImageLinks: ()=>useImageLinks
});
const _react = require("react");
const _ = require("..");
const appConfigs = {};
const useImageLinks = ()=>{
    const { setFullLogo , setNavLogo , setDarkBackground , setLightBackground  } = (0, _.useSpringBigStore)();
    const { merchantOrg  } = (0, _.useAppSettings)();
    (0, _react.useEffect)(()=>{
        if (merchantOrg) {
            const _merchantOrg = merchantOrg.replace(/\s/g, '').toLowerCase();
            setDarkBackground(`${_.IMG_URL}/${_merchantOrg}/background-dark.png`);
            setLightBackground(`${_.IMG_URL}/${_merchantOrg}/background-light.png`);
            if (_merchantOrg !== 'springbig' && _merchantOrg !== 'notconfigured') {
                setFullLogo(`${_.IMG_URL}/${_merchantOrg}/home-logo.png`);
                setNavLogo(`${_.IMG_URL}/${_merchantOrg}/logo.png`);
            }
        }
    }, [
        merchantOrg
    ]);
};
